import React from 'react';
import Icon from '../../../components/AppIcon';

const LiveStatusBanner = ({ status }) => {
  const statusConfig = {
    normal: {
      bgColor: 'bg-success/10',
      borderColor: 'border-success',
      textColor: 'text-success',
      icon: 'CheckCircle',
      message: 'All Systems Operational'
    },
    warning: {
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning',
      textColor: 'text-warning',
      icon: 'AlertTriangle',
      message: 'Active Weather Advisory'
    },
    critical: {
      bgColor: 'bg-error/10',
      borderColor: 'border-error',
      textColor: 'text-error',
      icon: 'AlertCircle',
      message: 'Emergency Alert Active'
    }
  };

  const config = statusConfig?.[status?.level] || statusConfig?.normal;

  return (
    <div className={`${config?.bgColor} border-l-4 ${config?.borderColor} p-4 mb-6 rounded-lg`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Icon name={config?.icon} size={24} className={config?.textColor} />
          <div>
            <h3 className={`${config?.textColor} font-semibold text-lg`}>{config?.message}</h3>
            <p className="text-foreground text-sm">{status?.details}</p>
          </div>
        </div>
        
        <div className="flex items-center gap-4">
          <div className="text-right">
            <div className="text-xs text-muted-foreground">Last Updated</div>
            <div className="text-foreground font-medium">{status?.lastUpdated}</div>
          </div>
          <div className="flex items-center gap-1">
            <div className={`w-2 h-2 rounded-full ${config?.textColor?.replace('text-', 'bg-')} pulse-conservation`}></div>
            <span className="text-xs text-muted-foreground">Live</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveStatusBanner;